import { jsx } from 'react/jsx-runtime';
import { Empty, Button } from '@flex-design-system/fx';
import { RefreshIcon, RobotIcon } from '@flex-design-system/legacy-flex-icons';
import { useTranslation, Translation } from '@flex-mf/i18n';

function ErrorView(props) {
  const {
    size: sizeFromProps,
    topSlot: topSlotFromProps,
    title: titleFromProps,
    subtext: subtextFromProps,
    onClickRetry,
    ...rest
  } = props;
  const { t } = useTranslation();
  const size = sizeFromProps ?? "default";
  const topSlot = topSlotFromProps ?? /* @__PURE__ */ jsx(RobotIcon, { type: "fill", color: "blackAlpha012" });
  const title = titleFromProps ?? t("@flex-services/async-boundary.global.error_view.default_title");
  const subtext = subtextFromProps ?? t("@flex-services/async-boundary.global.error_view.default_subtext");
  return /* @__PURE__ */ jsx(
    Empty,
    {
      size,
      topSlot,
      title: /* @__PURE__ */ jsx(Empty.Title, { children: title }),
      subtext: /* @__PURE__ */ jsx(Empty.Subtext, { children: subtext }),
      actionSlot: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "outline",
          size: "small",
          color: "gray",
          leftSlot: /* @__PURE__ */ jsx(RefreshIcon, {}),
          onClick: onClickRetry,
          children: /* @__PURE__ */ jsx(Translation, { tKey: "@flex-services/async-boundary.global.\uB2E4\uC2DC_\uC2DC\uB3C4\uD558\uAE30" })
        }
      ),
      ...rest
    }
  );
}

export { ErrorView as default };
//# sourceMappingURL=ErrorView.mjs.map
